export const newline = (text: string) => text.replace(/(\n|\r\n)/g, "<br />");
